<template>
  <VView class="contest-legals" :header="$t('contestLegals.header')">
    <VForm ref="form"
      :fields="fields"
      @update="onFormUpdate($event)"
    />

    <VBlock max-width="300px">
      <transition name="bounceUp" appear>
        <VButton @click="submit()">{{ $t('contestLegals.next') }}</VButton>
      </transition>
    </VBlock>
  </VView>
</template>

<script>
import { mapState } from 'vuex';
import { SET_LEGAL_FIELD } from '@/store';
import {
  FIELD_TYPE_COMMENT,
  FIELD_TYPE_CHECKBOX,
} from '@/components/VForm.vue';

export default {
  name: 'ContestLegals',

  data: () => ({
    isLoading: false,
  }),

  computed: {
    ...mapState({
      fields(state) {
        return [
          {
            key: 'legal1',
            type: FIELD_TYPE_CHECKBOX,
            isRequired: true,
            label: this.$t('contestLegals.legal1'),
            value: state.legal.legal1,
            width: '100%',
          },
          {
            key: 'legal2',
            type: FIELD_TYPE_CHECKBOX,
            isRequired: true,
            label: this.$t('contestLegals.legal2'),
            value: state.legal.legal2,
            width: '100%',
          },
          {
            key: 'legal3',
            type: FIELD_TYPE_CHECKBOX,
            isRequired: false,
            label: this.$t('contestLegals.legal3'),
            value: state.legal.legal3,
            width: '100%',
          },
          {
            key: 'reminder',
            type: FIELD_TYPE_COMMENT,
            isRequired: false,
            label: '',
            value: this.$t('contestLegals.reminder'),
            width: '100%',
          },
          {
            key: 'legal4',
            type: FIELD_TYPE_CHECKBOX,
            isRequired: true,
            label: this.$t('contestLegals.legal4'),
            value: state.legal.legal4,
            width: '100%',
          },
          {
            key: 'legal5',
            type: FIELD_TYPE_CHECKBOX,
            isRequired: true,
            label: this.$t('contestLegals.legal5'),
            value: state.legal.legal5,
            width: '100%',
          },
          {
            key: 'info',
            type: FIELD_TYPE_COMMENT,
            isRequired: false,
            label: '',
            value: this.$t('contestLegals.info'),
            width: '100%',
          },
          {
            key: 'required',
            type: FIELD_TYPE_COMMENT,
            isRequired: false,
            label: '',
            value: this.$t('contestLegals.required'),
            width: '100%',
          },
        ];
      },

      payload: state => ({
        ...state.personal,
        ...state.legal,
        answer: state.answer,
        attachment: state.attachment,
        score: state.score,
      }),
    }),
  },

  methods: {
    onFormUpdate({ key, value }) {
      this.$store.commit(SET_LEGAL_FIELD, { key, value });
    },

    async submit() {
      if (this.isLoading) {
        return;
      }

      const isValid = this.$refs.form.validate();

      if (!isValid) {
        return;
      }

      this.isLoading = true;

      try {
        await this.$bricodes.createEntry(this.payload);

        this.$router.push('/contest/end');

      } catch (error) {
        this.$router.push(`/contest/error?to=/contest/legals`);

        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.contest-legals {}
</style>
